import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onResetFilters, hasActiveFilters }) => {
  return (
    <div className="bg-card rounded-lg p-8 md:p-12 text-center shadow-warm-sm border border-border">
      <div className="w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
      </div>
      <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-2">
        No Institutions Found
      </h3>
      <p className="text-sm md:text-base text-muted-foreground mb-6 max-w-md mx-auto">
        {hasActiveFilters
          ? "We couldn't find any institutions matching your current filters. Try adjusting your search criteria." :"Start your search by entering keywords or applying filters to discover Chinese language programs."}
      </p>
      {hasActiveFilters && (
        <Button
          variant="default"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onResetFilters}
        >
          Reset All Filters
        </Button>
      )}
    </div>
  );
};

export default EmptyState;